export function togglePayout() {
  let toggleBtn = $('.js-payout-delete-toggle');
  toggleBtn.on('click', function() {
    toggleBtn.css('display', 'none');
    $('.js-payout-delete-form').css('display', 'block');
  });
}
